import React from 'react';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { colors } from '../../../themes/colors';
import { ComboBoxOption } from '../constants';
import { TestID } from './constants';

export type Props = WithStyles<typeof styles> & {
  hasErrorState?: boolean;
  onClick: () => void;
  selectedOption: ComboBoxOption;
};

const SelectedOptionBtn: React.FC<Props> = ({
  classes,
  hasErrorState = false,
  onClick,
  selectedOption,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();

    onClick();
  };

  const buttonClassName = classNames(
    'flex',
    'justify-between',
    'text-sm',
    'w-full',
    'p-2',
    'font-extrabold',
    'bg-white',
    'rounded-md',
    'border',
    'border-gray-300',
    {
      [classes.errorState]: hasErrorState,
    },
  );

  return (
    <button className={buttonClassName} data-testid={TestID} onClick={handleClick}>
      <div className="inline-flex pr-2 text-gray-800 whitespace-no-wrap">
        {selectedOption.displayText}
      </div>

      {selectedOption.subText && (
        <div className="inline-flex font-normal text-gray-500 truncate">
          {selectedOption.subText}
        </div>
      )}
    </button>
  );
};

const styles = () =>
  createStyles({
    errorState: {
      border: `1.5px solid ${colors.red6}`,
    },
  });

export default withStyles(styles)(SelectedOptionBtn);
